"use client";

import Image from "next/image";
import ImageAgency from "@/assets/images/About_xylo_header.webp"
import ImageCrafting from "@/assets/images/Crafting_exceptional.webp";
import LeadingAI from "@/assets/images/Leading_AI.webp";
import Elevating1 from "@/assets/images/Elevating_1.webp";
import Elevating2 from "@/assets/images/Elevating_2.webp";
import Elevating3 from "@/assets/images/Elevating_3.webp";
import About1 from "@/assets/images/demo-branding-agency-about-01.png";
import About2 from "@/assets/images/demo-branding-agency-about-02.png";
import CircularImage from "@/assets/images/Circular-Xylo.png";
import logo_dark from "@/assets/svg/Logo_Xylo_texte_circulaire.svg";
import Image1 from "@/assets/images/Image_1.webp"
import Image2 from "@/assets/images/Image_2.webp"
import Image3 from "@/assets/images/Image_3.webp"

export default function AgencyComponent (props) {
    return (<>
        
        <section className="p-0 top-space-margin position-relative overflow-hidden">
            <div className="container-fluid p-0 h-100 position-relative">
                <div className="row g-0">
                    <div className="col-xl-4 col-lg-5 d-flex justify-content-center align-items-center ps-10 xxl-ps-6 xl-ps-4 md-ps-4 sm-ps-0 position-relative order-2 order-lg-1" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <div className="vertical-title-center align-items-center justify-content-center flex-shrink-0 w-75px sm-w-50px">
                            <h1 className="title fs-15 alt-font text-dark-gray fw-700 text-uppercase ls-1px text-uppercase d-flex w-auto align-items-center m-0" data-fancy-text='{ "opacity": [0, 1], "translateY": [50, 0], "filter": ["blur(20px)", "blur(0px)"], "string": ["about xylo"], "duration": 400, "delay": 0, "speed": 50, "easing": "easeOutQuad" }'></h1>
                        </div>
                        <div className="border-start border-color-extra-medium-gray ps-40px sm-ps-20px position-relative z-index-9">
                            <h2 className="text-dark-gray fw-600 alt-font outside-box-right-10 xl-outside-box-right-15 lg-outside-box-right-20 md-me-0 sm-mb-0 ls-minus-3px">Revolutionizing copywriting with AI innovation.</h2>
                        </div>
                    </div>
                    <div className="col-xl-8 col-lg-7 position-relative one-half-screen order-1 order-lg-2 md-mb-50px"> 
                        <div className="overflow-hidden position-relative">
                            <div className="w-100" data-anime='{ "effect": "slide", "direction": "lr", "color": "#f7f7f7", "duration": 1000, "delay": 0 }'>
                                <Image src={ImageAgency} alt="" className="w-100 liquid-parallax" data-parallax-liquid="true" data-parallax-position="top" data-parallax-scale="1.05"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section>
            <div className="container">
                <div className="row mb-6 sm-mb-50px">
                    <div className="col-md-12 text-center text-md-start" data-anime='{"opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <div className="fs-140 xxl-fs-100 sm-fs-60 fw-600 text-dark-gray alt-font ls-minus-8px sm-ls-minus-2px" data-bottom-top="transform: translate3d(-50px, 0px, 0px);" data-top-bottom="transform: translate3d(50px, 0px, 0px);">AI content hub</div>
                    </div>
                    <div className="col-12">
                        <div className="row align-items-center align-items-lg-end" data-bottom-top="transform: translate3d(-30px, 0px, 0px);" data-top-bottom="transform: translate3d(30px, 0px, 0px);">
                            <div className="col-lg-3 col-md-4 text-md-end text-center md-mt-30px md-mb-20px" data-anime='{"opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                                <div className="position-relative">
                                    <Image src={CircularImage} style={{width: "109px", height: "110px"}} className="animation-rotation position-relative z-index-2" alt=""/>
                                    <div className="absolute-middle-center w-100 d-flex justify-content-center justify-content-md-end z-index-1">
                                            {/* <Image src={About2} alt=""/> */}
                                        <div className="position-relative mr-0" style={{width: "109px", height: "110px"}}>
                                            <Image className="position-absolute top-50 start-50 translate-middle" src={logo_dark} alt=""/>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 text-center text-md-start" data-anime='{"opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                                <div className="fs-140 xxl-fs-100 sm-fs-60 fw-600 text-dark-gray alt-font ls-minus-8px sm-ls-minus-2px">agency</div>
                            </div>
                            <div className="col-lg-4 last-paragraph-no-margin md-mt-30px" data-anime='{"opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                                <p className="w-95 md-w-80 mx-auto text-center text-lg-start sm-w-100">Crafting Content That Defines Brands. Our AI-driven creativity transforms your vision into success stories.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-0 counter-style-04" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                    <div className="col-lg-3 col-md-6 feature-box text-start hover-box border-start sm-border border-color-extra-medium-gray ps-35px pe-35px pt-25px pb-25px lg-ps-25px lg-pe-25px md-ps-35px md-pe-35px md-mb-50px sm-mb-30px">
                        <div className="feature-box-content">
                            <p className="text-dark-gray mb-20 sm-mb-10 fw-500 w-90 fs-17 lh-28">Content Pieces Generated in 2023.</p>
                            <h2 className="vertical-counter d-inline-flex text-dark-gray fw-700 ls-minus-2px mt-25 alt-font mb-0" data-text="K+" data-to="20"><sup className="text-dark-gray top-0"><i className="feather icon-feather-arrow-up icon-small"></i></sup></h2>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 feature-box text-start hover-box border-start sm-border border-color-extra-medium-gray md-border-end ps-35px pe-35px pt-25px pb-25px lg-ps-25px lg-pe-25px md-mb-50px sm-mb-30px">
                        <div className="feature-box-content">
                            <p className="text-dark-gray mb-20 sm-mb-10 fw-500 w-90 fs-17 lh-28">Successfully completed copywriting projects </p>
                            <h2 className="vertical-counter d-inline-flex text-dark-gray fw-700 ls-minus-2px mt-25 alt-font mb-0" data-text="K+" data-to="50"><sup className="text-dark-gray top-0"><i className="feather icon-feather-arrow-up icon-small"></i></sup></h2>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 feature-box text-start hover-box border-start sm-border border-color-extra-medium-gray ps-35px pe-35px pt-25px pb-25px lg-ps-25px lg-pe-25px sm-mb-30px">
                        <div className="feature-box-content">
                            <p className="text-dark-gray mb-20 sm-mb-10 fw-500 w-90 fs-17 lh-28">Monthly customers using Xylo’s services</p>
                            <h2 className="vertical-counter d-inline-flex text-dark-gray fw-700 ls-minus-2px mt-25 alt-font mb-0" data-text="K+" data-to="90"><sup className="text-dark-gray top-0"><i className="feather icon-feather-arrow-up icon-small"></i></sup></h2>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 feature-box text-start hover-box border-start sm-border border-color-extra-medium-gray md-border-end ps-35px pe-35px pt-25px pb-25px lg-ps-25px lg-pe-25px">
                        <div className="feature-box-content">
                            <p className="text-dark-gray mb-20 sm-mb-10 fw-500 w-90 fs-17 lh-28">Growth in client onboarding.</p>
                            <h2 className="vertical-counter d-inline-flex text-dark-gray fw-700 ls-minus-2px mt-25 alt-font mb-0" data-text="%" data-to="40"><sup className="text-dark-gray top-0"><i className="feather icon-feather-arrow-up icon-small"></i></sup></h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="pt-0">
            <div className="container">
                <div className="row mb-17 sm-mb-30px">
                    <div className="col-lg-6 position-relative">
                        {/* <div className="row align-items-center position-relative md-mb-15" data-anime='{ "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                            
                            <div className="w-100 overflow-hidden  " data-animation-delay="100" data-bottom-top="transform: translateY(20px)" data-top-bottom="transform: translateY(-20px)">
                                <Image src={LeadingAI} alt="" className="w-100" />
                            </div>
                        </div>  */}

                        <div class="row align-items-center position-relative md-mb-15" data-anime='{ "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                            <div class="col-md-6 sm-mb-30px" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)">
                                <Image className="w-100" src={Image1} alt="" style={{minWidth: "261px"}}  />
                            </div>
                            <div className="col-lg-6 col-md-6 sm-mb-30px text-end" data-bottom-top="transform: translateY(-30px)" data-top-bottom="transform: translateY(30px)">
                                <Image src={Image2} alt="" className="box-shadow-quadruple-large md-w-100" />
                            </div>
                            <div className="w-50 sm-w-100 overflow-hidden position-absolute sm-position-relative left-140px bottom-minus-200px sm-bottom-0px sm-left-0px p-0 sm-ps-15px sm-pe-15px" data-shadow-animation="true" data-animation-delay="100" data-bottom-top="transform: translateY(20px)" data-top-bottom="transform: translateY(-20px)">
                                <Image src={Image3} alt="" className="box-shadow-quadruple-large w-100"/>
                            </div>
                        </div> 

                    </div>
                    <div className="col-xl-5 col-lg-6 offset-xl-1 md-mt-20 sm-mt-0" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <div className="mb-10px">
                            <span className="w-25px h-1px d-inline-block bg-base-color me-5px align-middle"></span>
                            <span className="text-gradient-base-color-custom fs-15 alt-font fw-700 ls-05px text-uppercase d-inline-block align-middle">LEADING AI COPYWRITING AGENCY</span>
                        </div>
                        <h4 className="text-dark-gray alt-font fw-600 ls-minus-2px mb-20px">Empowering your brand with AI-driven creativity for success.</h4>
                        <p className="w-90 md-w-100 mb-35px sm-mb-20px">We craft content that resonates. Our AI-driven solutions infuse your brand with a distinctive voice, propelling it towards success. We tailor content strategies that engage your audience and drive action.</p>
                        <a href="/pricing" className="btn btn-large btn-dark-gray btn-switch-text btn-box-shadow border-1 left-icon me-10px sm-mb-15px sm-mt-15px">
                            <span>
                                <span><i className="feather icon-feather-send"></i></span>
                                <span className="btn-double-text" data-text="Get started">Get started</span> 
                            </span>
                        </a> 
                        <a href="/services" className="btn btn-large btn-transparent-light-gray border-1 btn-switch-text left-icon sm-mb-15px sm-mt-15px">
                            <span>
                                <span><i className="feather icon-feather-briefcase"></i></span>
                                <span className="btn-double-text" data-text="Our services">Our services</span> 
                            </span>
                        </a>
                    </div>
                </div> 
                <div className="row row-cols-1 row-cols-lg-5 row-cols-md-3 row-cols-sm-2 clients-style-06 justify-content-center mb-3 sm-mb-0" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                    
                    <div className="col client-box text-center md-mb-35px">
                        <a href="#"><img src="images/logo-walmart.svg" className="h-35px" alt=""/></a>
                    </div>
                    
                    
                    <div className="col client-box text-center md-mb-35px">
                        <a href="#"><img src="images/logo-logitech.svg" className="h-35px" alt=""/></a>
                    </div>
                    
                    
                    <div className="col client-box text-center md-mb-35px">
                        <a href="#"><img src="images/logo-monday.svg" className="h-35px" alt=""/></a>
                    </div>
                    
                    
                    <div className="col client-box text-center sm-mb-35px">
                        <a href="#"><img src="images/logo-google.svg" className="h-35px" alt=""/></a>
                    </div> 
                    
                    
                    <div className="col client-box text-center">
                        <a href="#"><img src="images/logo-paypal.svg" className="h-35px" alt=""/></a>
                    </div> 
                    
                </div>
            </div>
        </section>
        
        <section className="py-0">
            <div className="container">
                <div className="row align-items-center position-relative">
                    <div className="col-lg-6">
                        <div className="outside-box-left-20 md-outside-box-left-0 overflow-hidden position-relative" data-parallax-liquid="true" data-parallax-transition="2" data-parallax-position="top">
                            <div className="liquid-parallax" data-parallax-liquid="true" data-parallax-position="bottom" data-parallax-scale="1.1" data-parallax-scale-fraction="0.0001">
                                <Image className="w-100" src={ImageCrafting} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6 offset-xl-1 z-index-9 md-mt-50px" data-anime='{ "el": "childs", "translateX": [30, 0], "opacity": [0,1], "duration": 300, "delay": 0, "staggervalue": 100, "easing": "easeOutQuad" }'>
                        <h1 className="text-dark-gray alt-font mb-50px fw-600 ls-minus-2px md-mb-25px outside-box-left-15 md-outside-box-left-0 word-break-normal md-w-80 sm-w-100">Crafting exceptional AI-powered copy for your brand.</h1>
                        <p className="fs-20 fw-500 ls-minus-05px text-dark-gray mb-15px">Committed to elevating your brand’s voice with measurable success.</p>
                        <p className="w-90 md-w-100 mb-35px">We stand as a beacon of innovation and reliability in AI-driven copywriting services, consistently delivering content that makes an impact.</p>
                        <div className="progress-bar-style-02 mb-40px">
                            
                            <div className="progress mb-15px border-radius-50px fw-600 fs-11 lh-12 text-white bg-white">
                                <div className="progress-bar bg-gradient-orange-transparent m-0" role="progressbar" aria-valuenow="98" aria-valuemin="0" aria-valuemax="100" aria-label="business-growth">
                                    <span className="progress-bar-percent text-orange fw-600">98%</span>
                                </div>
                                <div className="progress-bar-title text-uppercase">CLIENT SATISFACTION</div>
                            </div>
                            
                            
                            <div className="progress border-radius-50px fw-600 fs-11 lh-12 text-white bg-white">
                                <div className="progress-bar bg-gradient-blue-transparent m-0" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" aria-label="new-technology">
                                    <span className="progress-bar-percent text-blue fw-600">85%</span>
                                </div>
                                <div className="progress-bar-title text-uppercase">INCREASE IN CLIENT RETENTION</div>
                            </div>
                            
                        </div>
                        <div className="pt-20px pb-20px ps-30px pe-30px xs-p-15px border border-color-extra-medium-gray border-radius-6px mb-15px icon-with-text-style-08 w-90 lg-w-100">
                            <div className="feature-box feature-box-left-icon-middle d-inline-flex align-middle">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-people icon-very-medium text-dark-gray"></i>
                                </div>
                                <div className="feature-box-content">
                                    <span className="alt-font fs-19 ls-minus-05px fw-600 text-dark-gray d-block lh-26">200k+ people trusting Xylo.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section className="pb-0">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 md-mb-20px sm-mb-0" data-anime='{ "el": "childs", "translateY": [15, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'> 
                        <h3 className="text-dark-gray fw-600 ls-minus-2px alt-font">Elevating brands with AI-enhanced copywriting.</h3> 
                    </div>
                    <div className="col-lg-7" data-anime='{ "el": "childs", "translateY": [15, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <div className="row">
                            <div className="col-md-5">
                                <div className="fs-19 fw-600 text-dark-gray w-90 xl-w-100 sm-mb-10px">Elevating your narrative with AI precision.</div>
                            </div>
                            <div className="col-md-7 last-paragraph-no-margin">
                                <p>At Xylo, we blend AI innovation with creative expertise to exceed customer expectations, transforming every project into a success story.</p>
                            </div>
                        </div>
                        <div className="separator-line-1px border-bottom border-color-extra-medium-gray mt-35px mb-35px"></div>
                        <div className="row">
                            <div className="col-md-5">
                                <div className="fs-19 fw-600 text-dark-gray w-90 xl-w-100 sm-mb-10px">Collaborating to craft unforgettable brands.</div>
                            </div>
                            <div className="col-md-7 last-paragraph-no-margin">
                                <p>We harness the power of AI to deliver content that not only meets but surpasses our clients’ goals, ensuring each brand’s voice is heard loud and clear.</p>
                            </div>
                        </div>
                        <div className="separator-line-1px border-bottom border-color-extra-medium-gray mt-35px mb-35px"></div>
                        <div className="row">
                            <div className="col-md-5">
                                <div className="fs-19 fw-600 text-dark-gray w-90 xl-w-100 sm-mb-10px">Pioneering AI-driven content solutions.</div>
                            </div>
                            <div className="col-md-7 last-paragraph-no-margin">
                                <p>Our commitment at Xylo is to leverage AI for creating distinctive digital content, making every client’s brand stand out in a crowded digital landscape.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <section>
            <div className="container">
                <div className="row row-cols-1 row-cols-lg-3 row-cols-sm-2" data-anime='{ "el": "childs", "translateY": [30, 0], "rotateX":[30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                    
                    <div className="col team-style-10 md-mb-30px">
                        <figure className="mb-0 position-relative overflow-hidden">
                            <Image src={Elevating1} alt="" />
                        </figure>
                    </div>
                    
                    
                    <div className="col team-style-10 md-mb-30px">
                        <figure className="mb-0 position-relative overflow-hidden">
                            <Image src={Elevating2} alt="" />
                        </figure>
                    </div>
                    
                    
                    <div className="col team-style-10">
                        <figure className="mb-0 position-relative overflow-hidden">
                            <Image src={Elevating3} alt="" />
                        </figure>
                    </div>
                    
                </div>
            </div>
        </section>

        
        
        </>)
}